import bbbLogo from '@perpay-web/components/assets/images/bbb.png';
import BackButton from '@perpay-web/components/base/BackButton/BackButton';
import { useTransparentStatusBar } from '@perpay-web/fintech/hooks/useTransparentStatusBar';
import { getPartnerOnboardingLogo } from '@perpay-web/fintech/utils/partnerOnboardingUtils';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './CardApplicationHeader.scss';

/**
 * @typedef {Object} MarketplaceApplicationHeaderProps
 * @property {string} [className=''] - Additional CSS class name
 * @property {string} [partnerCode=null] - Partner code for logo and branding
 * @property {Function} [onBackClicked=noop] - Callback function when back button is clicked
 */

/**
 * @param {MarketplaceApplicationHeaderProps} props
 */
const MarketplaceApplicationHeader = ({
    className = '',
    partnerCode = null,
    onBackClicked,
}) => {
    useTransparentStatusBar();
    const { partnerLogo, partnerLogoClassName } =
        getPartnerOnboardingLogo(partnerCode);

    return (
        <div className={getClassName(styles.header, className)}>
            <div className={styles.header__content}>
                {onBackClicked ? (
                    <BackButton
                        onClick={onBackClicked}
                        className={styles['back-button']}
                    />
                ) : null}
                <div className={styles.container}>
                    {partnerCode ? (
                        <>
                            <img
                                src={partnerLogo}
                                alt='Partner Logo'
                                className={styles[partnerLogoClassName]}
                            />
                            <div className={styles.container__divider} />
                        </>
                    ) : null}
                    <div className={styles['perpay-marketplace-logo']} />
                    <div className={styles.container__divider} />

                    <img
                        src={bbbLogo}
                        alt='Better Business Bureau Logo'
                        className={styles['better-business-bureau']}
                    />
                </div>
            </div>
        </div>
    );
};

export default MarketplaceApplicationHeader;
